import { render, staticRenderFns } from "./BasicProfileQuestionRow.vue?vue&type=template&id=1b27d43d&"
import script from "./BasicProfileQuestionRow.vue?vue&type=script&lang=js&"
export * from "./BasicProfileQuestionRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports